import { apiClient } from '@/lib/api/client';
import type { ApiEnvelope } from '@/types/api';
import type { Notification } from '@/types/notification';

export async function getNotifications(): Promise<ApiEnvelope<Notification[]>> {
  return apiClient.get<Notification[]>('/api_partner/notifications');
}

export async function markNotificationRead(id: string): Promise<ApiEnvelope<null>> {
  return apiClient.post<null>(`/api_partner/notifications/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<ApiEnvelope<null>> {
  return apiClient.post<null>('/api_partner/notifications/mark_all_as_read');
}
